"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountActivationOtpChallenge = AccountActivationOtpChallenge;
var _react = _interopRequireDefault(require("react"));
var _lucideReact = require("lucide-react");
var _reactI18next = require("react-i18next");
var _inputOtp = require("@/components/ui/input-otp");
var OTP_SLOTS = ['one', 'two', 'three', 'four', 'five', 'six'];
/** Shared six-digit OTP presentation for account enrollment placements. */
function AccountActivationOtpChallenge(_ref) {
  var title = _ref.title,
    description = _ref.description,
    helpText = _ref.helpText,
    leadingVisual = _ref.leadingVisual,
    code = _ref.code,
    errorMessage = _ref.errorMessage,
    _ref$invalid = _ref.invalid,
    invalid = _ref$invalid === void 0 ? false : _ref$invalid,
    loading = _ref.loading,
    verifying = _ref.verifying,
    countdown = _ref.countdown,
    onCodeChange = _ref.onCodeChange,
    onClose = _ref.onClose,
    onResend = _ref.onResend,
    testId = _ref.testId,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus;
  var _useTranslation = (0, _reactI18next.useTranslation)('payment'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "relative mb-6 mt-0 rounded-3xl bg-gray-50 px-5 py-7 text-center shadow-md sm:my-6 sm:px-10",
    "data-testid": testId,
    "data-sentry-component": "AccountActivationOtpChallenge",
    "data-sentry-source-file": "AccountActivationOtpChallenge.tsx"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "absolute right-4 top-4 rounded p-1 text-gray-500 hover:text-gray-800 focus:outline-none focus:ring-2 focus:ring-primary-regular",
    "aria-label": t('checkout_account_activation.close'),
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_lucideReact.X, {
    "aria-hidden": "true",
    className: "h-5 w-5",
    "data-sentry-element": "X",
    "data-sentry-source-file": "AccountActivationOtpChallenge.tsx"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-auto flex max-w-2xl items-start justify-center gap-3 pr-6 ".concat(leadingVisual ? 'text-left' : 'text-center')
  }, leadingVisual, /*#__PURE__*/_react["default"].createElement("div", null, title ? /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm font-normal text-gray-800"
  }, title) : null, /*#__PURE__*/_react["default"].createElement("p", {
    className: "".concat(title ? 'mt-1' : '', " text-center text-sm text-gray-500")
  }, description))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-auto mt-5 max-w-md",
    "aria-busy": verifying
  }, /*#__PURE__*/_react["default"].createElement(_inputOtp.InputOTP, {
    maxLength: 6,
    value: code,
    disabled: verifying || loading,
    onChange: onCodeChange,
    containerClassName: "w-full justify-center",
    "aria-label": t('checkout_account_activation.code_label'),
    autoComplete: "one-time-code",
    inputMode: "numeric",
    autoFocus: autoFocus,
    "data-sentry-element": "InputOTP",
    "data-sentry-source-file": "AccountActivationOtpChallenge.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_inputOtp.InputOTPGroup, {
    className: "w-full justify-center gap-1 transition-opacity sm:gap-2 ".concat(verifying ? 'opacity-50' : ''),
    "data-sentry-element": "InputOTPGroup",
    "data-sentry-source-file": "AccountActivationOtpChallenge.tsx"
  }, OTP_SLOTS.map(function (slot, index) {
    return /*#__PURE__*/_react["default"].createElement(_inputOtp.InputOTPSlot, {
      key: slot,
      index: index,
      className: "h-12 w-full max-w-12 rounded-md bg-white text-lg shadow-md sm:h-14 ".concat(invalid ? 'border-error-strong text-error-strong data-[active=true]:border-error-strong data-[active=true]:ring-error-strong/30' : '')
    });
  }))), verifying ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-3 flex items-center justify-center gap-2 text-sm text-gray-600",
    role: "status"
  }, /*#__PURE__*/_react["default"].createElement(_lucideReact.Loader2, {
    "aria-hidden": "true",
    className: "h-4 w-4 animate-spin"
  }), t('checkout_account_activation.verifying')) : errorMessage ? /*#__PURE__*/_react["default"].createElement("p", {
    className: "mt-3 text-sm text-error-strong",
    role: "alert"
  }, errorMessage) : /*#__PURE__*/_react["default"].createElement("p", {
    className: "mt-3 text-sm text-gray-600"
  }, helpText)), /*#__PURE__*/_react["default"].createElement("p", {
    className: "mt-4 text-sm text-gray-500"
  }, countdown > 0 ? /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    t: t,
    i18nKey: "checkout_account_activation.resend_in",
    values: {
      time: "".concat(String(Math.floor(countdown / 60)).padStart(2, '0'), ":").concat(String(countdown % 60).padStart(2, '0'))
    },
    components: {
      time: /*#__PURE__*/_react["default"].createElement("strong", {
        className: "font-semibold text-gray-700"
      })
    }
  }) : /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "font-medium text-primary-regular underline underline-offset-4 disabled:opacity-50",
    disabled: loading || verifying,
    onClick: onResend
  }, loading ? t('checkout_account_activation.sending') : t('checkout_account_activation.resend'))));
}